import React, { useEffect, useState } from "react";
import api from "../api";
import PostCard from "../components/PostCard";

export default function SupportedPosts() {

  const [posts, setPosts] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {

    try {

      const { data } = await api.get("/posts/supported");

      setPosts(data.posts || []);

    } catch (e) {
      console.error(e);
    }

  };

  return (
    <div className="page">

      <h2 style={{ marginBottom: 20 }}>
        Supported posts
      </h2>

      {posts.map(p => (
        <PostCard key={p.id} p={p}/>
      ))}

    </div>
  );
}